/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext, useRef } from 'react'
import { ProductContext } from '../../context/addProductContext'
import useCart from '../../hooks/useCart'
import useTheme from '../../hooks/theme'
import useWindowResize from '../../hooks/useWindowResize'
import gql from 'graphql-tag'
import { useQuery } from '@apollo/react-hooks'
import { Client } from '../../apollo/client'
import isEqual from 'lodash.isequal'
import uniq from 'lodash.uniq'
import uniqWith from 'lodash.uniqwith'
import { graphql, useStaticQuery } from 'gatsby'
import { HelpCircle, Circle } from 'react-feather'
import '@reach/accordion/styles.css'
import '@reach/tooltip/styles.css'
import { ChevronUp } from 'react-feather'
import Dolphin from '../svg/dolphin'
import MineralSwim from '../svg/mineralSwim'
import OzoneSwim from '../svg/ozoneSwim'
import Mline from '../svg/m-line'
import Sline from '../svg/s-line'
import Xline from '../svg/x-line'
import Eline from '../svg/e-line'
import WaveLine from '../svg/wave'
import Fusion from '../svg/fusion-line'
import O3 from '../svg/o3-line'
import Swash from '../svg/swash-line'
import LibertyLine from '../svg/liberty-line'
import SkimmiLine from '../svg/skimmi-line'
import EonLine from '../svg/eon-line'
import { onAddToCart } from '../utils/analytics'
import tw, { css, styled } from 'twin.macro'
import getCurreny from '../utils/currency'
const windowGlobal = typeof window !== 'undefined' && window
import {
	DetailsSection,
	DetailsContainer,
	ProductContainer,
	ProductTitle,
	ProductsName,
	RemoveSvg,
	ImageRow,
	BrandImage,
	ImageContainer,
	ProductImage,
	SkuContainer,
	SkuTitle,
	Sku,
	LineContainer,
	LineTitle,
	ProductLineContainer,
	RrpContainer,
	RrpTitle,
	Rrp,
	FeatureRow,
	Acc,
	AccItem,
	AccButton,
	AccPanel,
	AccordionButtonHolder,
	CheckMark,
	CustomizedToolTip,
	AddToCartContainer,
	AddToCartTitle,
	AddBook,
	AddToCart,
	Request,
	Book,
} from './styles'

const APOLLO_TAB_DETAILS_QUERY = gql`
	query tabDetailsQuery($title: [String]!, $locale: String!) {
		maindetails: productCollection(
			locale: $locale
			where: { seoTitle_in: $title }
		) {
			items {
				seoTitle
				model
				brand
				sku
				series
				price
				slug
				active
				shippingClass
				categories {
					title: seoTitle
				}
				imagesCollection {
					items {
						url
					}
				}
				brandPage {
					media {
						url
						description
					}
				}
				seriesPage {
					media {
						url
						description
					}
				}
			}
		}
	}
`
const APOLLO_SPEC_QUERY = gql`
	query specDetails($title: [String]!, $locale: String!) {
		specificationdetails: productCollection(
			locale: $locale
			where: { seoTitle_in: $title }
		) {
			items {
				seoTitle
				specifications
			}
		}
	}
`
const APOLLO_FEATURE_QUERY = gql`
	query featureDetails($title: [String]!, $locale: String!) {
		featuredetails: productCollection(
			locale: $locale
			where: { seoTitle_in: $title }
		) {
			items {
				seoTitle
				featuresCollection {
					items {
						title
						description
					}
				}
			}
		}
	}
`
const TabDetails = ({
	addDetails,
	tabDetails,
	activeSlug,
	removeAddDits,
	locale,
}) => {
	const [table, setTable] = useContext(ProductContext)
	const [dataPlot, setDataPlot] = useState([])
	const [productDatas, setProductDatas] = useState(undefined)
	const [specificationsData, setSpecificationsData] = useState(undefined)
	const [featureDetails, setFeatureDetails] = useState(undefined)
	const [isOpen, toggle] = useState(false)
	const [isFeatureOpen, featureToggle] = useState(false)
	const { height, width } = useWindowResize()
	const clickHandler = () => {
		toggle(!isOpen)
	}
	const featureClickHandler = () => {
		featureToggle(!isFeatureOpen)
	}

	useEffect(() => {
		const tabDtl = windowGlobal.sessionStorage.getItem(activeSlug)
		if (width < 1023) {
			const alteredDataPlot = [...dataPlot]
			if (alteredDataPlot.length > 2) {
				alteredDataPlot.splice(
					alteredDataPlot.length - 1,
					alteredDataPlot.length - 1
				)
				setDataPlot(alteredDataPlot)
			}
		} else {
			setDataPlot(JSON.parse(tabDtl))
		}
	}, [width])

	useEffect(() => {
		const tabDtl = windowGlobal.sessionStorage.getItem(activeSlug)
		if (
			table.length === 0 &&
			addDetails.length === 0 &&
			tabDetails.length === 0
		) {
			if (tabDtl != null) {
				setDataPlot(JSON.parse(tabDtl))
				return
			}
		}
		if (tabDetails.length > 0 || tabDetails.length === 0) {
			setDataPlot(tabDetails)
		}
	}, [table, activeSlug])

	useEffect(() => {
		if (addDetails.length > 0) {
			setDataPlot(addDetails)
		}
	}, [table])

	useEffect(() => {
		const tabDtl = windowGlobal.sessionStorage.getItem(activeSlug)
		setDataPlot(JSON.parse(tabDtl))
	}, [locale])

	const { loading, error, data } = useQuery(APOLLO_TAB_DETAILS_QUERY, {
		fetchPolicy: 'no-cache',
		variables: { title: dataPlot, locale: locale },
		client: Client,
	})
	const { loading: specLoading, error: specError, data: specData } = useQuery(
		APOLLO_SPEC_QUERY,
		{
			fetchPolicy: 'no-cache',
			variables: { title: dataPlot, locale: locale },
			client: Client,
		}
	)
	const {
		loading: featureLoading,
		error: featureError,
		data: featureData,
	} = useQuery(APOLLO_FEATURE_QUERY, {
		fetchPolicy: 'no-cache',
		variables: { title: dataPlot, locale: locale },
		client: Client,
	})

	useEffect(() => {
		if (data != undefined) {
			const xx = [...data.maindetails.items]
			const sortedDatas = xx.sort((a, b) => {
				return dataPlot.indexOf(a.seoTitle) - dataPlot.indexOf(b.seoTitle)
			})
			xx.splice(0, xx.length, ...sortedDatas)
			const newdata = { ...data }
			newdata.maindetails.items = sortedDatas
			setProductDatas(newdata)
		}
	}, [data])
	useEffect(() => {
		if (specData != undefined) {
			const xx = [...specData.specificationdetails.items]
			const sortedDatas = xx.sort((a, b) => {
				return dataPlot.indexOf(a.seoTitle) - dataPlot.indexOf(b.seoTitle)
			})
			xx.splice(0, xx.length, ...sortedDatas)
			const newdata = { ...specData }
			newdata.specificationdetails.items = sortedDatas
			setSpecificationsData(newdata)
		}
	}, [specData])
	useEffect(() => {
		if (featureData != undefined) {
			const xx = [...featureData.featuredetails.items]
			const sortedDatas = xx.sort((a, b) => {
				return dataPlot.indexOf(a.seoTitle) - dataPlot.indexOf(b.seoTitle)
			})
			xx.splice(0, xx.length, ...sortedDatas)
			const newdata = { ...featureData }
			newdata.featuredetails.items = sortedDatas
			setFeatureDetails(newdata)
		}
	}, [featureData])

	const feature =
		featureDetails != undefined
			? featureDetails.featuredetails.items
					.map((x, i) => {
						return x.featuresCollection
					})
					.map(x => {
						return x.items.map(y => {
							return y.title
						})
					})
					.sort((a, b) => {
						return b.length - a.length
					})
					.reduce((accumulator, current) => {
						return accumulator.concat(current)
					}, [])
			: []

	const uniqueFeatureKeys = uniq([...feature])
	const alteredFeatureKeys = uniqueFeatureKeys.map((x, i) => {
		return {
			featurekeys: x,
			arraydata: [],
			tooltip: [],
		}
	})
	featureDetails != undefined
		? featureDetails.featuredetails.items.map((x, i) => {
				const title = []
				const description = []
				x.featuresCollection.items.map((a, b) => {
					title.push(a.title)
					description.push(a)
				})
				const arr = []
				uniqueFeatureKeys.map((x, y) => {
					const xx = title.includes(x)
					if (xx) {
						description.map((a, b) => {
							if (x === a.title) {
								arr.push('check')
							}
						})
					} else {
						arr.push('')
					}
				})
				arr.map((a, b) => {
					alteredFeatureKeys[b].arraydata.push(a)
				})
		  })
		: []

	const featureToolTip =
		featureDetails != undefined
			? featureDetails.featuredetails.items
					.map((x, i) => {
						return x.featuresCollection
					})
					.map(x => {
						return x.items.map(y => {
							return y
						})
					})
					.sort((a, b) => {
						return b.length - a.length
					})
					.reduce((accumulator, current) => {
						return accumulator.concat(current)
					}, [])
			: []
	const uniqueTooltip = uniqWith(featureToolTip, isEqual)

	uniqueTooltip.map((x, y) => {
		alteredFeatureKeys[y].tooltip.push(x.description)
	})

	const spec =
		specificationsData != undefined
			? specificationsData.specificationdetails.items
					.map((x, i) => {
						return x.specifications
					})
					.map(x => {
						return x.map(y => {
							return y.spec
						})
					})
					.sort((a, b) => {
						return b.length - a.length
					})
					.reduce((accumulator, current) => {
						return accumulator.concat(current)
					}, [])
			: []

	const uniqueKeys = uniq([...spec])
	const alteredKeys = uniqueKeys.map((x, i) => {
		return {
			featurekeys: x,
			arraydata: [],
		}
	})
	specificationsData != undefined
		? specificationsData.specificationdetails.items.map((x, i) => {
				const specs = []
				const details = []
				x.specifications.map((a, b) => {
					specs.push(a.spec)
					details.push(a)
				})
				const arr = []
				uniqueKeys.map((x, y) => {
					const xx = specs.includes(x)
					if (xx) {
						details.map((a, b) => {
							if (x === a.spec) {
								arr.push(a.detail ? a.detail : a.details)
							}
						})
					} else {
						arr.push('')
					}
				})
				arr.map((a, b) => {
					alteredKeys[b].arraydata.push(a)
				})
		  })
		: []

	const removeProductHandler = (name, index) => {
		const fetchSession = sessionStorage.getItem(activeSlug)
		const parseSession = JSON.parse(fetchSession)
		const filteredSession = parseSession.filter((item, i) => {
			return item != name
		})
		sessionStorage.setItem(activeSlug, JSON.stringify(filteredSession))
		const stateData = { ...productDatas }
		const specsData = { ...specificationsData }
		const featureDits = { ...featureDetails }
		const alterData = stateData.maindetails.items
		const alterSpecs = specsData.specificationdetails.items
		const alterFeature = featureDits.featuredetails.items
		alterData.splice(index, 1)
		alterSpecs.splice(index, 1)
		alterFeature.splice(index, 1)
		const replaceStateData = { ...productDatas }
		const replaceSpecsData = { ...specificationsData }
		const replaceFeatureData = { ...featureData }
		const alterStateData = [...replaceStateData.maindetails.items].splice(
			0,
			alterData.length,
			...alterData
		)
		const alterSpecData = [
			...replaceSpecsData.specificationdetails.items,
		].splice(0, alterSpecs.length, ...alterSpecs)
		const alterFeatureData = [
			...replaceFeatureData.featuredetails.items,
		].splice(0, alterFeature.length, ...alterFeature)
		setDataPlot(filteredSession)
		removeAddDits(filteredSession)
		setProductDatas(replaceStateData)
		setSpecificationsData(replaceSpecsData)
		setFeatureDetails(replaceFeatureData)
	}

	const { addToCart } = useCart()
	const { openCart } = useTheme()

	const { productImage } = useStaticQuery(graphql`
		query allProduct {
			productImage: allContentfulProduct(
				filter: { node_locale: { in: ["en-AU", "en-NZ", "en-ZA"] } }
			) {
				edges {
					node {
						node_locale
						slug
						images {
							fluid(maxWidth: 600, maxHeight: 400, quality: 60) {
								src
								srcWebp
							}
							description
						}
					}
				}
			}
		}
	`)

	const dataCheck = () => {
		return productDatas != undefined
			? productDatas.maindetails.items.length > 0
				? true
				: false
			: false
	}
	const check = dataCheck()
	const modelTitleMap = {
		'S 100 Bonus': 'Dolphin S 100 Bonus Pack',
		'S 250 Bonus': 'Dolphin S 250 Bonus Pack',
		'S 150 Bonus': 'Dolphin S 150 Bonus Pack',
		'Liberty Bundle': 'Dolphin Liberty 400 Bundle'
	}
	const [isSticky, setSticky] = useState(false)
	const [place, setPlace] = useState(false)
	const [initialOffset, setInitialOffset] = useState(false)
	const [ttlHeight, setTtlHeight] = useState(false)
	const [btnOffset, setBtnOffset] = useState(false)
	const ref = useRef(null)
	const btnRef = useRef(null)
	const ttlRef = useRef(null)
	const handleScroll = () => {
		ref != null ? setPlace(ref?.current?.getBoundingClientRect()?.top) : ''
		ref != null
			? setSticky(
					ref && ref.current && ref.current.getBoundingClientRect().top <= 0
			  )
			: ''
		ttlRef != null ? setTtlHeight(ttlRef?.current?.offsetHeight) : ''
		btnRef != null ? setBtnOffset(btnRef?.current?.offsetTop) : ''
	}
	useEffect(() => {
		window.addEventListener('scroll', handleScroll)

		return () => {
			window.removeEventListener('scroll', () => handleScroll)
		}
	}, [])
	useEffect(() => {
		ref != null
			? setInitialOffset(ref?.current?.getBoundingClientRect()?.top)
			: ''
		btnRef != null ? setBtnOffset(btnRef?.current?.offsetTop) : ''
	}, [ref, btnRef])

	const totalHeight = Math.abs(place) + ttlHeight + initialOffset

	const currency = getCurreny(locale)
	const getCountry = locale.split('-')[1].toLowerCase()
	return (
		<DetailsSection>
			<DetailsContainer ref={ref}>
				<div>
					<ProductContainer
						ref={ttlRef}
						css={
							isSticky
								? totalHeight >= btnOffset
									? tw`absolute bottom-0 left-0 right-0 z-10 top-auto`
									: tw`fixed pr-16 w-11/12 z-10`
								: {}
						}
					>
						{check === true ? (
							<>
								<ProductTitle>Product</ProductTitle>
								{productDatas.maindetails.items.map((item, i) => {
									// Scalable model title mapping
									const displayTitle = modelTitleMap[item.model] || item.seoTitle
									const splitString = displayTitle.split(item.brand)
									return (
										<ProductsName key={i}>
											<RemoveSvg
												width="25"
												height="25"
												onClick={() => {
													removeProductHandler(item.seoTitle, i)
												}}
											/>
											{item.brand}
											<br />
											<span>{splitString[1]}</span>
										</ProductsName>
									)
								})}
							</>
						) : (
							''
						)}
					</ProductContainer>
					<ImageRow>
						{check === true ? (
							<>
								<BrandImage>
									{activeSlug === 'residential' ||
									activeSlug === 'commercial' ? (
										<Dolphin width="100%" height="100" />
									) : (
										''
									)}
									{activeSlug === 'mineral-swim' ? (
										<MineralSwim width="100%" height="100" />
									) : (
										''
									)}
									{activeSlug === 'ozone-swim' ? (
										<OzoneSwim width="100%" height="100" />
									) : (
										''
									)}
								</BrandImage>
								{productDatas.maindetails.items.map((item, i) => {
									const filterImg = img => {
										return img.filter(x => {
											return x.node.slug === item.slug ? x : ''
										})
									}
									const filteredByslug = filterImg(productImage.edges)
									return (
										<ImageContainer key={i}>
											<ProductImage>
												<source
													srcSet={
														filteredByslug[0].node.images[0].fluid.srcWebp
													}
													type="image/webp"
												/>
												<source
													srcSet={`${
														filteredByslug[0].node.images[0].fluid.src.split(
															'?'
														)[0]
													}?fm=png&fl=png8&fit=pad&w=600&h=400`}
												/>
												<img
													src={filteredByslug[0].node.images[0].fluid.src}
													alt={
														filteredByslug[0].node.images[0].fluid.description
													}
												/>
											</ProductImage>
										</ImageContainer>
									)
								})}
							</>
						) : (
							''
						)}
					</ImageRow>
					<SkuContainer>
						{check === true ? (
							<>
								<SkuTitle>SKU</SkuTitle>
								{productDatas.maindetails.items.map((item, i) => {
									return <Sku key={i}>{item.sku}</Sku>
								})}
							</>
						) : (
							''
						)}
					</SkuContainer>
					<LineContainer>
						{check === true ? (
							<>
								<LineTitle>Line</LineTitle>
								{productDatas.maindetails.items.map((item, i) => {
									const sModels = ['S 100 Bonus', 'S 250 Bonus', 'S 150 Bonus']
                  					const seriesToShow = item && item.series == null && item.model && sModels.includes(item.model) ? 'S Line' : item.series
									return (
										<ProductLineContainer key={i}>
											{seriesToShow === 'M Line' ? (
												<Mline width="150" height="80" />
											) : (
												''
											)}
											{seriesToShow === 'S Line' ? (
												<Sline width="150" height="80" />
											) : (
												''
											)}
											{seriesToShow === 'X Line' ? (
												<Xline width="150" height="80" />
											) : (
												''
											)}
											{seriesToShow === 'Wave' ? (
												<WaveLine width="150" height="80" />
											) : (
												''
											)}
											{seriesToShow === 'O³ Line' ? (
												<O3 width="150" height="80" />
											) : (
												''
											)}
											{seriesToShow === 'Fusion Line' ? (
												<Fusion width="150" height="80" />
											) : (
												''
											)}
											{seriesToShow === 'Swash Line' ? (
												<Swash width="150" height="80" />
											) : (
												''
											)}
											{seriesToShow === 'Liberty Line' ? (
												<img src={LibertyLine.defaultProps.url} alt="Liberty Line" width="120" height="80" />
											) : (
												''
											)}
											{seriesToShow === 'EON Line' ? (
												<img src={EonLine.defaultProps.url} alt="Eon Line" width="150" height="80" />
											) : (
												''
											)}
											{seriesToShow === 'E Line' ? (
												<Eline width="150" height="80" />
											) : (
												''
											)}
											{seriesToShow === 'Skimmi Line' ? (
												<img src={SkimmiLine.defaultProps.url} alt="Skimmi Line" width="150" height="80" />
											) : (
												''
											)}
										</ProductLineContainer>
									)
								})}
							</>
						) : (
							''
						)}
					</LineContainer>
					<RrpContainer>
						{check === true ? (
							<>
								<RrpTitle>RRP</RrpTitle>
								{productDatas.maindetails.items.map((item, i) => {
									return (
										<Rrp key={i}>
											{item.series !== 'Wave' ? (
												<>
														{item.price.toLocaleString(locale, {
															style: 'currency',
															currency: currency,
														})}
												</>
											) : (
												''
											)}
										</Rrp>
									)
								})}
							</>
						) : (
							''
						)}
					</RrpContainer>
					{check === true ? (
						<Acc collapsible>
							<AccItem>
								<AccordionButtonHolder
									onClick={() => {
										clickHandler()
									}}
								>
									<AccButton>
										{isOpen ? (
											<ChevronUp className="up" />
										) : (
											<ChevronUp className="down" />
										)}
										Specifications
									</AccButton>
								</AccordionButtonHolder>
								<AccPanel>
									{alteredKeys.map((item, i) => {
										return (
											<FeatureRow key={i}>
												<p>{item.featurekeys}</p>
												{item.arraydata.map((data, i) => {
													return (
														<p
															className={Array.isArray(data) ? 'flexIt' : ''}
															key={i}
														>
															{Array.isArray(data)
																? data.map((x, y) => {
																		return (
																			<span key={y}>
																				<Circle
																					width="6"
																					height="6"
																					fill="#000"
																				/>
																				{x}
																			</span>
																		)
																  })
																: data}
														</p>
													)
												})}
											</FeatureRow>
										)
									})}
								</AccPanel>
							</AccItem>
						</Acc>
					) : (
						''
					)}
					{check === true ? (
						<Acc collapsible>
							<AccItem>
								<AccordionButtonHolder
									onClick={() => {
										featureClickHandler()
									}}
								>
									<AccButton>
										{isFeatureOpen ? (
											<ChevronUp className="up" />
										) : (
											<ChevronUp className="down" />
										)}
										Features
									</AccButton>
								</AccordionButtonHolder>
								<AccPanel>
									{alteredFeatureKeys.map((item, i) => {
										return (
											<FeatureRow key={i}>
												<div>
													<span>
														{item.featurekeys}
														<CustomizedToolTip label={item.tooltip}>
															<button>
																<HelpCircle
																	width="22px"
																	height="22px"
																	fill="#58c8df"
																	color="#fff"
																/>
															</button>
														</CustomizedToolTip>
													</span>
												</div>
												{item.arraydata.map((data, i) => {
													return (
														<p key={i}>
															{data === 'check' ? (
																<CheckMark
																	color="#000"
																	width="30"
																	height="30"
																/>
															) : (
																''
															)}
														</p>
													)
												})}
											</FeatureRow>
										)
									})}
								</AccPanel>
							</AccItem>
						</Acc>
					) : (
						''
					)}
				</div>
				<AddToCartContainer ref={btnRef}>
					{check === true ? (
						<>
							<AddToCartTitle></AddToCartTitle>
							{productDatas != undefined
								? productDatas.maindetails.items.map((x, y) => {
										return (
											<AddBook key={y}>
												{x.series != 'Wave' ? (
													x.active === null || x.active === true ? (
														<AddToCart
															onClick={() => {
																addToCart({
																	img: x.imagesCollection.items[0].url,
																	slug: x.slug,
																	name: x.model ? x.model : x.seoTitle,
																	sku: x.sku,
																	price: Number(x.price * 100),
																	quantity: 1,
																	shippingClass: x.shippingClass,
																})
																onAddToCart(
																	{
																		name: x.model ? x.model : x.seoTitle,
																		sku: x.sku,
																		price: Number(x.price * 100),
																		quantity: 1,
																		brand: x.brand,
																		category: [
																			x.categories && x.categories.title,
																		].toString(),
																		shippingClass: x.shippingClass,
																	},
																	'Category List'
																)
																openCart()
															}}
														>
															Add To Cart
														</AddToCart>
													) : locale === 'en-AU' ? (
														<Request
															to={`/support/contact/?subject=${encodeURIComponent(
																x.seoTitle.toLowerCase()
															)}#contact-form`}
														>
															Enquire Now
														</Request>
													) : (
														<Request to={`https://mydolphin.co.${getCountry}`}>
															Buy at MyDolphin
														</Request>
													)
												) : (
													<Request
														to={`/support/contact/?subject=commercial+trial+${encodeURIComponent(
															x.model.toLowerCase()
														)}#contact-form`}
													>
														Request a trial
													</Request>
												)}
												{x.series != 'Wave' &&
												(x.active === null || x.active === true) ? (
													<Book to={'/book-a-demo'}>Book a Demo</Book>
												) : (
													''
												)}
											</AddBook>
										)
								  })
								: ''}
						</>
					) : (
						''
					)}
				</AddToCartContainer>
			</DetailsContainer>
		</DetailsSection>
	)
}

export default TabDetails
